// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"16ed9d68","54":"953b25cb","354":"28e42a34"}[chunkId] + ".chunk.css";
};